import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getStatusDialerByAfid } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
//import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';
function mapStateToProps({auth,DashBoard}) {
    const { authUser} = auth;
    const { StatusTabel,DashboardDialerFilterOption} = DashBoard;
    return {
        authUser,StatusTabel,DashboardDialerFilterOption
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getStatusDialerByAfid: (Afid,userid,FilterOption) => dispatch(getStatusDialerByAfid(Afid,userid,FilterOption)),
        dispatch
    }
}
class Tabell extends Component {
    state={
        StatusTabel:{},
        DashboardDialerFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getStatusDialerByAfid(Afid,undefined,this.state.DashboardDialerFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })        
    }
    
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({done: false,})
                    const Afid = this.props.Afid;
                    this.props.getStatusDialerByAfid(Afid,undefined,this.state.DashboardDialerFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            30000
        );
      }
    componentDidUpdate=()=>{
       /* if(this.props.DashboardDialerFilterOption !== this.state.DashboardDialerFilterOption && !isEmpty(this.props.DashboardDialerFilterOption))
           {
                
               const Afid = this.props.Afid;
               this.props.getStatusDialerByAfid(Afid).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) 
               this.setState({
                DashboardDialerFilterOption:this.props.DashboardDialerFilterOption 
               }) 
           }*/
        }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    formatNumber=(number)=>{
        console.log(number)
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
    }
    render() {
        return (
            <div  style={{ width: '95%' }}>
                {this.state.done === false?  
                         <>
                         <div className="row mx-1">
                             <div className="col-12 row mx-1">
                                 <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                             </div>
                             <div className="col-12 row mx-1">
                                 <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                             </div>
                             <div className="col-12 row mx-1">
                                 <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                             </div>
                         </div>
                         </>
                         :
            <Table>
                <TableBody>
                    { 
                    isEmpty(this.props.StatusTabel)?"":
                    <>
                            <TableRow key={0}>
                                <TableCell align="left" style={{ paddingTop: this.props.paddingTabell, paddingBottom: this.props.paddingTabell, color: 'white', borderBottom: '1px solid #44D1C2' }}><IntlMessages id="DashBoard.Accept.Meeting"/></TableCell>
                                <TableCell align="right" style={{ paddingTop: this.props.paddingTabell, paddingBottom: this.props.paddingTabell, color: 'white', borderBottom: '1px solid #44D1C2', fontWeight: '500' }}>
                                {isUndefined(this.props.StatusTabel.Gmoten)?0:this.formatNumber(this.props.StatusTabel.Gmoten)} st
                                </TableCell>
                            </TableRow>
                            <TableRow key={1}>
                                <TableCell align="left" style={{ paddingTop: this.props.paddingTabell, paddingBottom: this.props.paddingTabell, color: 'white', borderBottom: '1px solid #44D1C2' }}><IntlMessages id="DashBoard.Quality"/></TableCell>
                                <TableCell align="right" style={{ paddingTop: this.props.paddingTabell, paddingBottom: this.props.paddingTabell, color: 'white', borderBottom: '1px solid #44D1C2', fontWeight: '500' }}>
                                {isUndefined(this.props.StatusTabel.Kvalit)?0:this.formatNumber(this.props.StatusTabel.Kvalit).toFixed(0)} %
                                </TableCell>
                            </TableRow>
                            <TableRow key={2}>
                                <TableCell align="left" style={{ paddingTop: this.props.paddingTabell, paddingBottom: this.props.paddingTabell, color: 'white', borderBottom: '1px solid #44D1C2' }}><IntlMessages id="DashBoard.NoAnswer"/></TableCell>
                                <TableCell align="right" style={{ paddingTop: this.props.paddingTabell, paddingBottom: this.props.paddingTabell, color: 'white', borderBottom: '1px solid #44D1C2', fontWeight: '500' }}>
                                {isUndefined(this.props.StatusTabel.EjSvar)?0:this.formatNumber(this.props.StatusTabel.EjSvar)} st
                                </TableCell>
                            </TableRow>
                            <TableRow key={3}>
                                <TableCell align="left" style={{ paddingTop: this.props.paddingTabell, paddingBottom: this.props.paddingTabell, color: 'white', borderBottom: '1px solid #44D1C2' }}><IntlMessages id="Table.Return.Personal.Short"/></TableCell>
                                <TableCell align="right" style={{ paddingTop: this.props.paddingTabell, paddingBottom: this.props.paddingTabell, color: 'white', borderBottom: '1px solid #44D1C2', fontWeight: '500' }}>
                                {isUndefined(this.props.StatusTabel.AterkP)?0:this.formatNumber(this.props.StatusTabel.AterkP)} st
                                </TableCell>
                            </TableRow>
                            <TableRow key={4}>
                                <TableCell align="left" style={{ paddingTop: this.props.paddingTabell, paddingBottom: this.props.paddingTabell, color: 'white', borderBottom: '1px solid transparent' }}><IntlMessages id="Table.No.Thanks"/></TableCell>
                                <TableCell align="right" style={{ paddingTop: this.props.paddingTabell, paddingBottom: this.props.paddingTabell, color: 'white', borderBottom: '1px solid transparent', fontWeight: '500' }}>
                                {isUndefined(this.props.StatusTabel.NejTack)?0:this.formatNumber(this.props.StatusTabel.NejTack)} st
                                </TableCell>
                            </TableRow>
                    </>
                    }
                </TableBody>
            </Table>
            }
        </div> 
        )
    }
}
export default connect(
    mapStateToProps,mapDispatchToProps
  )(Tabell);

